function fbq() {
  return typeof window !== 'undefined' ? window.fbq : null;
}

function logEvent(name, params) {
  try {
    if (typeof window === 'undefined') return;
    window.__metaPixelEvents = window.__metaPixelEvents || [];
    window.__metaPixelEvents.push({ name, params, ts: new Date().toISOString() });
  } catch (_) {}
}

export function trackMetaPageView() {
  try {
    fbq()?.('track', 'PageView');
    logEvent('PageView', {});
  } catch (_) {}
}

export function trackMetaViewContent(params = {}) {
  try {
    fbq()?.('track', 'ViewContent', params);
    logEvent('ViewContent', params);
  } catch (_) {}
}

export function trackMetaLead(params = {}) {
  try {
    fbq()?.('track', 'Lead', params);
    logEvent('Lead', params);
  } catch (_) {}
}

export function trackMetaCompleteRegistration(params = {}) {
  try {
    const payload = { value: 0, currency: 'USD', status: 'completed', ...params };
    fbq()?.('track', 'CompleteRegistration', payload);
    logEvent('CompleteRegistration', payload);
  } catch (_) {}
}

export function trackMetaStartTrial(params = {}) {
  try {
    const payload = { value: 0, currency: 'USD', ...params };
    fbq()?.('track', 'StartTrial', payload);
    logEvent('StartTrial', payload);
  } catch (_) {}
}
